import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/customer-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/customer-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/customer-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/customer-profiles/${data.customer_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/customer-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getcustomertype = (Options = {}) => {
  return httpClient
    .get('/api/customer-profiles/customer-types', Option)
    .then(response => Promise.resolve(response.data))
}

export const getcustomerzone = (Options = {}) => {
  return httpClient
    .get('/api/customer-profiles/customer-zones', Option)
    .then(response => Promise.resolve(response.data))
}

export const getservicetype = (Options = {}) => {
  return httpClient
    .get('/api/customer-profiles/service-types', Option)
    .then(response => Promise.resolve(response.data))
}

export default {
  get,
  store,
  find,
  update,
  destroy,
  getcustomertype,
  getcustomerzone,
  getservicetype
}
